import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { createBrowserRouter, RouterProvider } from 'react-router';

import App from './App';
import MobxProvider from './mobx/store-provider';

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <NuqsAdapter>
        <MobxProvider>
          <App />
        </MobxProvider>
      </NuqsAdapter>
    ),
  },
]);

const AppRouter = () => {
  return <RouterProvider router={router} />;
};

export default AppRouter;
